module.exports = __webpack_public_path__ + "static/media/helping-customer-aboutus.3eab8dfc.jpeg";